﻿export class AppPermissionOverviewModel {
    AppId: string;
    FunctionalityId: string;
    JurisdictionId: string;

}